define('views/modules/calendar/nutrition/entry/suggestion-item',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // interface
    'views/modules/calendar/nutrition/entry/food-receptor-interface',
    // views
    'views/modules/calendar/nutrition/entry/food-entry-list-item',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // interface
    FoodReceptorInterface,
    // views
    VFoodEntryListItem
) {

    var VFoodEntrySuggestionItem = VFoodEntryListItem.extend(_.extend({}, FoodReceptorInterface, {
        className: "food-suggestion-item",

        events: {
            "click .suggestion-delete": "onSuggestionDeleteClick",
            "click .suggestion-drop-zone": "onDropZoneClick",
        },

        constructor: function(options) {
            var parent = VFoodEntryListItem.prototype;
            this.events = _.extend({}, parent.events, this.events);
            VFoodEntryListItem.apply(this, arguments);
        },

        initialize: function(options) {
            VFoodEntrySuggestionItem.__super__.initialize.apply(this, arguments);

            this.listenTo(this.model, {
                'change:_food': this.render,
            });
        },

        render: function() {
            VFoodEntrySuggestionItem.__super__.render.apply(this, arguments);
            this.updateFoodClass();
            return this;
        },

        getData: function() {
            return _.extend({
                suggestion: this.model.getSuggestionText(),
            }, this.getFood().toJSON());
        },

        updateFoodClass: function() {
            this.$el.toggleClass('no-food', !this.model.hasFood());
        },

        addEntry: function(food) {
            if (food.tag) {
                U.warn("Can't set a suggestion as the food item for a suggestion");
                return;
            }
            var model = this.model;
            model.setFood(food.attributes);

            if (model.hasFood()) model.getFood().fetch();

            U.log("addEntry", food, model.attributes);
        },
        toggleChosen: function(value) {
            this.setActive(value);
        },

        ////////////
        // events //
        ////////////
        onDropZoneClick: function() {
            this.model.trigger('entry:suggest', this.model, this);
        },
        onSuggestionDeleteClick: function() {
            this.model.trigger('entry:remove', this.model);
        },
        onDeleteClick: function(e) {
            this.model.removeFood();
        },
    }));

    return VFoodEntrySuggestionItem;
});

